module.exports = __webpack_public_path__ + "static/privacy-5ed8ec9fe075a710065c27e21717329d.jpg";